// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"983":"077a8060","1192":"c49fe5df","1433":"8c7ea5d3","1520":"9a0d361c","6974":"97470e44","9683":"97470e44"}[chunkId] + ".chunk.css";
};